import { MatchingCalcAi } from './matching-calc-ai.model';
import { MailCustomTag } from './mail-custom-tag.model';
export class MailInfo {
  age: number;
  ai_mail_id: string;
  already_offered: string;
  already_read: string;
  belong_to_own_company: boolean;
  body: string;
  body_json: string;
  company_code: string;
  company_id: number;
  country_of_citizenship: string;
  created_at: string;
  employment_status: string;
  employment_status_name: string;
  fee: number;
  estimate_fee: number;
  id: number;
  important_line_judge: string;
  interview_times: number;
  is_best: boolean|null = null;
  is_mail_already_offered: boolean;
  keywords: object;
  location_latitude: number;
  location_longitude: number;
  mail_cc: string;
  mail_from: string;
  mail_from_name: string;
  mail_probability_0: number;
  mail_probability_1: number;
  mail_row_datas: string;
  mail_to: string;
  mail_register_id: number;
  multi_received_mail: boolean;
  multiple_ai_mail_parent_id: string;
  multiple_flag: boolean;
  multiple_flag_probability_0: number;
  multiple_flag_probability_1: number;
  number_of_connect_company: number;
  order_finished: boolean;
  others: string;
  position: number;
  rawdata_url: string;
  receipt_datetime: string;
  retransmision_flag: boolean;
  sender_hash_id: string;
  sex: string;
  title: string;
  title_json: string;
  transmited_number: string;
  updated_at: string;
  user_code: string;
  user_focus: boolean;
  user_id: number;
  work_immidiately: string;
  work_immidiately_name: string;
  work_location: string;
  commute_time: number;
  matching_score: MatchingCalcAi;
  attached_file_ids: Array<number>;
  attached_files: Array<any>;
  matched_skills: Array<string>;
  is_time_out_to_approve: boolean;
  mail_custom_tags: Array<MailCustomTag>;
  showOtherThanImportantLine: boolean;
  is_pair_already_offered: boolean;
  // reply用
  msg_body: string;
  msg_from: string;
  msg_subj: string;

  constructor(hash: any) {
    if (Object.keys(hash).length) {
      this.age = hash.age;
      this.ai_mail_id = hash.ai_mail_id;
      this.already_offered = hash.already_offered;
      this.already_read = hash.already_read;
      this.body = hash.body;
      this.body_json = hash.body_json;
      this.company_code = hash.company_code;
      this.company_id = hash.company_id;
      this.country_of_citizenship = hash.country_of_citizenship;
      this.created_at = hash.created_at;
      this.employment_status = hash.employment_status;
      this.employment_status_name = hash.employment_status_name;
      this.fee = hash.fee;
      this.estimate_fee = hash.estimate_fee;
      this.id = hash.id;
      this.important_line_judge = hash.important_line_judge;
      this.interview_times = hash.interview_times;
      this.is_mail_already_offered = hash.is_mail_already_offered;
      this.keywords = hash.keywords;
      this.location_latitude = hash.location_latitude;
      this.location_longitude = hash.location_longitude;
      this.mail_cc = hash.mail_cc;
      this.mail_from = hash.mail_from;
      this.mail_from_name = hash.mail_from_name;
      this.mail_probability_0 = hash.mail_probability_0;
      this.mail_probability_1 = hash.mail_probability_1;
      this.mail_row_datas = hash.mail_row_datas;
      this.mail_to = hash.mail_to;
      this.multi_received_mail = hash.multi_received_mail;
      this.multiple_ai_mail_parent_id = hash.multiple_ai_mail_parent_id;
      this.multiple_flag = hash.multiple_flag;
      this.multiple_flag_probability_0 = hash.multiple_flag_probability_0;
      this.multiple_flag_probability_1 = hash.multiple_flag_probability_1;
      this.number_of_connect_company = hash.number_of_connect_company;
      this.order_finished = hash.order_finished;
      this.others = hash.others;
      this.position = hash.position;
      this.rawdata_url = hash.rawdata_url;
      this.receipt_datetime = hash.receipt_datetime;
      this.retransmision_flag = hash.retransmision_flag;
      this.sender_hash_id = hash.sender_hash_id;
      this.sex = hash.sex;
      this.title = hash.title;
      this.title_json = hash.title_json;
      this.transmited_number = hash.transmited_number;
      this.updated_at = hash.updated_at;
      this.user_code = hash.user_code;
      this.user_focus = hash.user_focus;
      this.user_id = hash.user_id;
      this.work_immidiately = hash.work_immidiately;
      this.work_immidiately_name = hash.work_immidiately_name;
      this.work_location = hash.work_location;
      this.matching_score = hash.matching_score;
      this.attached_file_ids = hash.attached_file_ids;
      this.attached_files = hash.attached_files;
      this.matched_skills = hash.matched_skills;
      this.is_time_out_to_approve = hash.is_time_out_to_approve;
      this.mail_custom_tags = hash.mail_custom_tags;
      this.is_pair_already_offered = hash.is_pair_already_offered;
    }
  }
}
